import styled, { css } from 'styled-components';
import { FlexCenterBoth } from 'components/primitives/flex';
import LoadingSpinner from 'components/loading/LoadingSpinner';
import { mediaMMdMin, mediaXlMin } from 'helpers/breakpoints';

export const InboxPageLayout = styled.div`
  display: grid;
  height: 100vh;
  height: calc(100 * var(--vh));
  max-height: 100vh;
  padding: 60px 0 0 0;

  grid-template-columns: 1fr;

  ${mediaMMdMin} {
    grid-template-columns: 35% 1fr;
  }
  @media ${mediaXlMin} {
    grid-template-columns: 1fr 2fr 1fr;
  }
`;

export const panelScrollMixin = css`
  overflow: auto;
  height: 100%;
  max-height: calc(100vh - 60px);
`;

export const panelMobileStyles = css`
  position: fixed;
  z-index: 2000;
  inset: 0;
  background-color: #fff;
  height: 100vh;
  height: calc(100 * var(--vh));
`;

export const Loader = (props) => (
  <FlexCenterBoth padding="20px" mt="20px" {...props}>
    <LoadingSpinner color="#72D4BA" />
  </FlexCenterBoth>
);
